import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { TalleresList } from "./talleres/TalleresList";
import Seo from "./Head";
import { CartContext } from "../context/CartContext";

const Talleres = () => {
  // Usamos useEffect para el scroll para seguir las buenas prácticas de React
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombreCategoria } = useParams();
  const { items, isLoading } = useContext(CartContext);

  // 1. FILTRADO CON LÓGICA DE PAUSADOS
  const productosCategoria = items.filter((p) => {
    // Filtramos por categoría (insensible a mayúsculas por seguridad)
    const esTaller = p.categoria?.toLowerCase() === "talleres";

    // FILTRO DE ESTADO: Solo pasan los que NO están pausados
    const estaActivo = p.estado?.toLowerCase() !== "pausado";

    return esTaller && estaActivo;
  });

  // 2. ORDENAMIENTO (Mantenemos tu lógica de stock)
  productosCategoria.sort((a, b) => a.stock - b.stock);

  return (
    <>
      <Seo
        title={"Talleres - Espacio Analógico"}
        description={
          "Aprendé fotografía analógica, revelado y procesos químicos."
        }
        pathSlug={window.location.href}
      />

      <div className="item row pt-4 mt-4">
        {/* Agregamos una validación simple por si no hay talleres activos */}
        {productosCategoria.length > 0 ? (
          <TalleresList items={productosCategoria} />
        ) : (
          <div className="text-center py-5 col-12">
            <h3 className="letraGris">
              No hay talleres disponibles por el momento.
            </h3>
          </div>
        )}
      </div>
    </>
  );
};

export default Talleres;
